import { memo } from 'react';
import styled from 'styled-components';

import { useString } from 'app/hooks';
import { uniqueId } from 'lodash';

import { ReactComponent as IconDefaultItemDisable } from 'app/assets/icons/icon-default-item-disable.svg';
import { ReactComponent as IconTrash } from 'app/assets/icons/icon-trash.svg';
import { ReactComponent as ImageDefault } from 'app/assets/icons/image-default-edit.svg';

const ShowImage = styled.div`
  min-width: 160px;
  min-height: 160px;
  width: 160px;
  height: 160px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  position: relative;
`;
const UploadImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;
const UploadImageLabel = styled.label`
  width: 100%;
  height: 100%;
`;
const ButtonIconTrash = styled.div`
  background-color: var(--danger);
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
`;
interface Props {
  file: File | null;
  image: string;
  isEdit?: boolean;
  setFile: (newFile: File | null) => void;
  isDisable?: boolean;
  isRemoveImage: boolean;
  setIsRemoveImage: (value: boolean) => void;
}

const AddImageItemCard: React.FC<Props> = ({
  file,
  image,
  isRemoveImage,
  isDisable = false,
  setFile,
  setIsRemoveImage,
}) => {
  const keyInputFile = useString();

  const fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentFiles: any = [];
    if (event.target.files) {
      for (const [, f] of Object.entries(event.target.files)) {
        currentFiles.push(f);
      }
    }
    if (currentFiles.length) {
      setFile(currentFiles[0]);
    }
    keyInputFile.setValue(uniqueId('item_'));
  };
  const renderImage = () => {
    if (file) {
      return `url(${URL.createObjectURL(file)})`;
    }
    if (image) {
      return `url(${image})`;
    }

    return 'inherit';
  };
  const renderImageAdd = () => {
    if (file) {
      return null;
    }
    if (!image && isDisable) {
      return (
        <IconDefaultItemDisable
          style={{
            width: 160,
            height: 160,
          }}
        />
      );
    }
    if (isRemoveImage || !image) {
      return (
        <ImageDefault
          style={{
            width: 160,
            height: 160,
          }}
        />
      );
    }
    return null;
  };

  const showIconRemove = () => {
    if (isDisable) {
      return false;
    }
    if (file) {
      return true;
    }
    if (!image) {
      return false;
    }
    return !isRemoveImage;
  };
  return (
    <ShowImage
      style={{
        backgroundImage: renderImage(),
      }}
    >
      <UploadImage>
        <input
          id="container-update-image"
          onChange={fileSelectedHandler}
          accept={'image/*'}
          type="file"
          style={{ display: 'none' }}
          key={keyInputFile.value || ''}
        />
        <UploadImageLabel
          htmlFor={isDisable ? '' : 'container-update-image'}
          style={{
            cursor: isDisable ? 'inherit' : 'pointer',
          }}
        >
          {renderImageAdd()}
        </UploadImageLabel>
      </UploadImage>
      {showIconRemove() ? (
        <ButtonIconTrash
          onClick={() => {
            setFile(null);
            setIsRemoveImage(true);
          }}
        >
          <IconTrash />
        </ButtonIconTrash>
      ) : null}
    </ShowImage>
  );
};
export default memo(AddImageItemCard);
